import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start User
export const getUsersAdminService = (params) => {
  return http.get(`${base_url}/admin/users`, { params });
};
export const createUserAdminService = (data) => {
  return http.post(`${base_url}/admin/user`, data);
};
export const editUserAdminService = (data) => {
  return http.put(`${base_url}/admin/user/${data.id}`, data);
};
export const changeUserActiveAdminService = (id) => {
  return http.patch(`${base_url}/admin/user/${id}/active`);
};
export const changeUserPasswordAdminService = (data) => {
  return http.patch(`${base_url}/admin/user/${data.id}/change-password`, data);
};
export const deleteUserAdminService = (id) => {
  return http.delete(`${base_url}/admin/user/${id}`);
};
// End User

// Start Transaction
export const createTransactionAdminService = (data) => {
  return http.post(`${base_url}/admin/transaction`, data);
};
// End Transaction

// Start Log
export const getLogsAdminService = (params) => {
  return http.get(`${base_url}/admin/log`, { params });
};
export const deleteAllLogAdminService = () => {
  return http.delete(`${base_url}/admin/log`);
};
export const deleteLogAdminService = (id) => {
  return http.delete(`${base_url}/admin/log/${id}`);
};
// End Log

// Start Product
export const getProductsAdminService = (params) => {
  return http.get(`${base_url}/admin/product`, { params });
};
export const createProductAdminService = (data) => {
  return http.post(`${base_url}/admin/product`, data);
};
export const createProductOrderAdminService = (data) => {
  return http.post(`${base_url}/admin/order/product`, data);
};
export const editProductAdminService = (data) => {
  return http.put(`${base_url}/admin/product/${data.id}`, data);
};
export const deleteProductAdminService = (id) => {
  return http.delete(`${base_url}/admin/product/${id}`);
};
// End Product

// Start Table
export const getTablesAdminService = (params) => {
  return http.get(`${base_url}/admin/table`, { params });
};
export const createTableAdminService = (data) => {
  return http.post(`${base_url}/admin/table`, data);
};
export const editTableAdminService = (data) => {
  return http.put(`${base_url}/admin/table/${data.id}`, data);
};
export const deleteTableAdminService = (id) => {
  return http.delete(`${base_url}/admin/table/${id}`);
};
// End Table

// Start Order
export const getOrdersAdminService = (params) => {
  return http.get(`${base_url}/admin/order`, { params });
};
export const createOrderAdminService = (data) => {
  return http.post(`${base_url}/admin/order`, data);
};
export const editOrderAdminService = (data) => {
  return http.put(`${base_url}/admin/order/${data.id}`, data);
};
export const deleteOrderAdminService = (id) => {
  return http.delete(`${base_url}/admin/order/${id}`);
};
// Start Order

// Start Cost
export const getCostsAdminService = (params) => {
  return http.get(`${base_url}/admin/cost`, { params });
};
export const createCostAdminService = (data) => {
  return http.post(`${base_url}/admin/cost`, data);
};
export const editCostAdminService = (data) => {
  return http.put(`${base_url}/admin/cost/${data.id}`, data);
};
export const deleteCostAdminService = (id) => {
  return http.delete(`${base_url}/admin/cost/${id}`);
};
// Start Cost

// Start Debtor
export const getDebtorsAdminService = (params) => {
  return http.get(`${base_url}/admin/debtor`, { params });
};
export const createDebtorAdminService = (data) => {
  return http.post(`${base_url}/admin/debtor`, data);
};
export const editDebtorAdminService = (data) => {
  return http.put(`${base_url}/admin/debtor/${data.id}`, data);
};
export const deleteDebtorAdminService = (id) => {
  return http.delete(`${base_url}/admin/debtor/${id}`);
};
// Start Debtor

// Start Cue
export const getCueAdminService = (params) => {
  return http.get(`${base_url}/admin/cue`, { params });
};
export const editCueAdminService = (data) => {
  return http.put(`${base_url}/admin/cue`, data);
};
// End Cue

// Start Setting
export const getSettingAdminService = (params) => {
  return http.get(`${base_url}/admin/setting`, { params });
};
export const editSettingAdminService = (data) => {
  return http.put(`${base_url}/admin/setting`, data);
};
// End Setting
